import React, { Component, Fragment } from "react";
import api from "../../../../../services/api";
import SelectMeta from "../../../../Educacao/Metas/SelectMeta";
import { Link } from "react-router-dom";
import swal from 'sweetalert';
import "./style.css";
import Tabela from "../../MetasPortfolio/Tabela";
import Formulario from "../Formulario/index"
import utils from "../../../utils/utils";

export default class Form extends Component {

    constructor(props) {
        super(props);
        
        this.state = {
            aplicationName: "Form Meta",
            cursos: null,
            cursoSelecionado: null,
            fonte: "",
            linhas: [
                "Consultoria em Tecnologia",
                "Serviços Técnicos Especializados",
                "Pesquisa, Desenvolvimento e Inovação",
                "Metrologia",
                "Serviços Complementares",
            ],
            servicos: [
                {
                    linhaAtuacao: "Consultoria em Tecnologia",
                    categoria: "Consultoria em Processos Produtivos",
                    cr: "3.02.01.02.02"
                },
                {
                    linhaAtuacao: "Consultoria em Tecnologia",
                    categoria: "Consultoria para Atendimento de Legislações, Normas e Regulamentos Técnicos",
                    cr: "3.02.01.02.04" 
                },
                {
                    linhaAtuacao: "Serviços Técnicos Especializados",
                    categoria: "Serviços Operacionais",
                    cr: "3.02.01.01.02" 
                },
                {
                    linhaAtuacao: "Pesquisa, Desenvolvimento e Inovação",
                    categoria: "Pesquisa, Desenvolvimento e Inovação de Processos",
                    cr: "3.02.02.01.02" 
                },
                {
                    linhaAtuacao: "Pesquisa, Desenvolvimento e Inovação",
                    categoria: "Pesquisa, Desenvolvimento e Inovação de Produto",
                    cr: "3.02.02.01.01" 
                },
                {
                    linhaAtuacao: "Metrologia",
                    categoria: "Calibração",
                    cr: "3.02.01.05.02" 
                },
                {
                    linhaAtuacao: "Metrologia",
                    categoria: "Ensaios",
                    cr: "3.02.01.05.01" 
                },
                {
                    linhaAtuacao: "Serviços Complementares",
                    categoria: "Consultoria em Gestão Empresarial",
                    cr: "3.02.01.02.02" 
                },
            ],
            linhaSelecionada: "",
            categorias: [],
            cr: "",
            produtos: [],
            produtoSelecionado: null,
            metas: []
        }

    }

    async componentDidUpdate(prevProps, prevState) {
        if(prevState.metas !== this.state.metas) {
            //await this.consultaMetas();
        }
    }

    async componentDidMount() {
        await this.consultaMetas();
    }

    onSubmit = async (event) => {

        try {

            event.preventDefault();
            let { numeroAtendimento, horasTecnicas, calibracoes, ensaios, relatoriosELaudos, receita, despesa } = event.target;
            let { mediaHH, totalHH, valorHora, receitaPrevista } = event.target;
            
            numeroAtendimento = [...numeroAtendimento].map(valor => Number(valor.value));
            horasTecnicas     = horasTecnicas && [...horasTecnicas].map(valor => Number(valor.value));
            calibracoes       = calibracoes && [...calibracoes].map(valor => Number(valor.value));
            ensaios           = ensaios && [...ensaios].map(valor => Number(valor.value));
            relatoriosELaudos = relatoriosELaudos && [...relatoriosELaudos].map(valor => Number(valor.value));
            receita           = [...receita].map(valor => Number(valor.value));
            despesa           = [...despesa].map(valor => Number(valor.value));

            let totalNumeroAtendimento = numeroAtendimento.reduce((acc, atual) => acc + atual, 0);
            let totalHorasTecnicas     = horasTecnicas && horasTecnicas.reduce((acc, atual) => acc + atual, 0);
            let totalCalibracoes       = calibracoes && calibracoes.reduce((acc, atual) => acc + atual, 0);
            let totalEnsaios           = ensaios && ensaios.reduce((acc, atual) => acc + atual, 0);
            let totalRelatoriosELaudos = relatoriosELaudos && relatoriosELaudos.reduce((acc, atual) => acc + atual, 0);
            let totalReceita           = receita.reduce((acc, atual) => acc + atual, 0);
            let totalDespesa           = despesa.reduce((acc, atual) => acc + atual, 0);

            totalHH = Number(mediaHH.value) * totalNumeroAtendimento;

            let { 
                linhaAtuacao, 
                categoria, 
                cr, 
                produtoNacional, 
                comentario,
                metaEmpresasAtendidas,
                metaAtendimentos,
                totalEnsaiosCalibracoes,
                totalLaudosRelatorios,
            } = event.target;

            let { 
                Sigla,
                Produto, 
                DescritivoProduto, 
                Objetivo, 
                ConteudoProgramatico, 
                ResultadosEsperados, 
                Beneficios, 
                ContaContabilId, 
                Nome, 
                Codigo,
                CodigoMascara,
                NomeNivel4,
                NomeNivel5
            } = this.state.produtoSelecionado;

            let cadastro = {
                linhaAtuacao: linhaAtuacao.value,
                categoria: categoria.value,
                cr: cr.value,
                produtoNacional: produtoNacional.value,
                comentario: comentario.value,
                metaEmpresasAtendidas: Number(metaEmpresasAtendidas.value),
                metaAtendimentos: Number(metaAtendimentos.value),
                mediaHH: Number(mediaHH.value),
                totalHH: totalHH,
                totalEnsaiosCalibracoes: Number(totalEnsaiosCalibracoes.value),
                totalLaudosRelatorios: Number(totalLaudosRelatorios.value),
                valorHora: Number(valorHora.value),
                receitaPrevista: Number(receitaPrevista.value),
                Sigla,
                Produto, 
                DescritivoProduto, 
                Objetivo, 
                ConteudoProgramatico, 
                ResultadosEsperados, 
                Beneficios, 
                ContaContabilId, 
                Nome, 
                Codigo,
                CodigoMascara,
                NomeNivel4,
                NomeNivel5,
                numeroAtendimento, 
                horasTecnicas, 
                calibracoes,
                ensaios,
                relatoriosELaudos,
                receita, 
                despesa
            }

            let valores = {
                totalCalibracoes, 
                totalEnsaios, 
                totalRelatoriosELaudos,
                totalNumeroAtendimento,
                totalHorasTecnicas
            } 

            let verif = [linhaAtuacao.value, categoria.value, produtoNacional.value];
            verif.map(v => {
                if(v.includes("Escolha")) throw new Error("erro Sigla");
            })

            if(utils.verificaCadastro(categoria.value, valores)) {
                let status = await api.post("/sti", cadastro);
                if(status.data.status === "ok") {
                    window.showNotification('Cadastrado com sucesso', 'success');
                    document.forms[0].reset();
                    utils.limpaSoma();
                }
                else window.showNotification(status.data.status || 'Erro ao cadastrar', 'danger');
                await this.consultaMetas();
            }
            else {
                window.showNotification(`Erro ao cadastrar: O valor total da soma dos meses deve ser igual aos valores previstos`, 'danger');
            }

        } catch(erro) {
            let mensagem = 'Erro ao cadastrar';
            if(erro.message.includes("Sigla")) mensagem = "Selecione a Linha da Atuação, Categorias e Produto para cadastrar"
            window.showNotification(mensagem, 'danger');
        }

    }

    onChangeLinha = (event) => {
        let linha = event.target.value;
        let categorias = this.state.servicos.filter(servico => servico.linhaAtuacao === linha);
        this.setState({ linhaSelecionada: event.target.value, categorias: categorias, produtos: [], produtoSelecionado: null });
        utils.limpar();
    }

    onChangeCategoria = async (event) => {
        let categoria = event.target.value;
        let selecionado = this.state.servicos.filter(servico => servico.categoria === categoria);
        let produtos = await this.consultaProdutos(categoria);
        if(produtos.length < 1) window.showNotification("Nenhum produto encontrado nessa categoria", 'warning');
        this.setState({ cr: selecionado[0].cr, produtos: produtos, produtoSelecionado: null });
        utils.limpar();
    }

    consultaProdutos = async (categoria) => {
        let produtos = await api.get("/sti");
        produtos = produtos.data.produtos;
        produtos = produtos.filter(produto => produto.NomeNivel5 === categoria && this.props.unidade === produto.Sigla.toLowerCase());
        return produtos;
    }

    onChangeProduto = async (event) => {
        let produtoSelecionado = event.target.value;
        produtoSelecionado = this.state.produtos.filter(produto => produto.Produto === produtoSelecionado);
        this.setState({ produtoSelecionado: produtoSelecionado[0] });
    }

    exibeFichaSweetAlert = (detalheProduto) => {
        let detalhe = utils.exibeDetalhe(detalheProduto);
        swal({
            content: {
                element: 'div',
                attributes: {
                    innerHTML: `${detalhe}`,
                },
            },
            showConfirmButton: true,
            html: true,
            width: '100px',
            customClass: 'swal-wide'
        });
    }

    exibeMetaSweetAlert = async (id) => {
        let detalheProduto = await api.get(`/sti/metas/${id}`);
        detalheProduto = detalheProduto.data.metas;

        let detalhe = utils.exibeDetalhe(detalheProduto);
        swal({
            content: {
                element: 'div',
                attributes: {
                    innerHTML: `${detalhe}`,
                },
            },
            showConfirmButton: true,
            html: true,
            width: '100px',
            customClass: 'swal-wide'
        });
    }

    excluirMeta = async (curso) => {
        let status = await api.delete(`/sti/metas/${curso}`);
        window.showNotification(typeof status.data.status === "string" ? status.data.status : 'Excluído com sucesso', 'danger');
        await this.consultaMetas();
    }

    consultaMetas = async () => {
        let metas = await api.get(`/sti/metas?unidade=${this.props.unidade.toUpperCase()}`);
        this.setState({ metas: metas.data.metas });
    }

    onChange = async () => {

        let valorHora = document.getElementById("valorHora").value;
        let linha = document.getElementById("linhaAtuacao").value
        let categoria = document.getElementById("categoria").value
        
        if(linha === "Metrologia") {
            let totalLaudosRelatorios = document.getElementById("totalLaudosRelatorios").value;
            document.getElementById("receitaPrevista").value = totalLaudosRelatorios * valorHora;
        }
        else {
            let metaAtendimentos = document.getElementById("metaAtendimentos").value;
            let mediaHH = document.getElementById("mediaHH").value;
            document.getElementById("totalHH").value = metaAtendimentos * mediaHH;
            
            let totalHH = document.getElementById("totalHH").value;
            document.getElementById("receitaPrevista").value = totalHH * valorHora;
        }

        if(categoria === "Calibração" || categoria === "Ensaios") {
            utils.calculaMetaMetrologiaAutomaticamente(categoria);
        }
        else {
            utils.calculaMetaAutomaticamente();
        }

        utils.informaSomaTotalAtual();

    }

    render() {
        return (
            <Fragment>
                <Formulario 
                    {...this.state}
                    onChangeLinha={this.onChangeLinha}
                    onChangeCategoria={this.onChangeCategoria}
                    onChangeProduto={this.onChangeProduto}
                    exibeFichaSweetAlert={this.exibeFichaSweetAlert}
                    onSubmit={this.onSubmit}
                    unidade={this.props.unidade}
                    onChange={this.onChange}
                />

                <Tabela 
                    {...this.state}
                    excluirMeta = {this.excluirMeta}
                    metas = {this.state.metas}
                    unidade = {this.props.unidade}
                    exibeFichaSweetAlert={this.exibeMetaSweetAlert}
                />

            </Fragment>
        )
    }

}